module.exports = __webpack_public_path__ + "img/thumb_33.b3165ffc.jpg";